import {
  GOOGLE_CONVERSION_PARTNER_ID,
  GOOGLE_MAPS_CONVERSION_COLLECT_ENDPOINT,
  GoogleMapsConversionCollectExperimentOptionsTypes,
  GoogleMapsConversionCollectExperimentOptions,
} from '../utils/constants'

export const triggerGoogleMapsConversionCollect = (
  rwgToken: string,
  googleMapsConversionCollectExperimentValue: Omit<
    GoogleMapsConversionCollectExperimentOptionsTypes,
    'off'
  >,
): Promise<any> => {
  const url =
    googleMapsConversionCollectExperimentValue ===
    GoogleMapsConversionCollectExperimentOptions.sandbox
      ? GOOGLE_MAPS_CONVERSION_COLLECT_ENDPOINT.sandbox
      : GOOGLE_MAPS_CONVERSION_COLLECT_ENDPOINT.prod

  return fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      conversion_partner_id: GOOGLE_CONVERSION_PARTNER_ID,
      rwg_token: rwgToken,
    }),
  })
}
